import { useLocation } from 'react-router-dom';
import { Container } from 'react-bootstrap';

import { useAppSelector } from 'store/hooks';
import { useGetScreenSize } from 'utils';

import { Banner } from './banner';
import { Navbar } from './navbar';

import './header.scss';
import { AgentBanner } from 'components/shared/agentBanner';

export const Header = (): JSX.Element => {
  const { pathname } = useLocation();
  const customerData = useAppSelector((state) => state.customerData);
  const { selectedPolicy } = customerData;
  const isAgent = useAppSelector((state) => state.authentication.isAgent);
  const { isTablet, isMobile } = useGetScreenSize();

  const showBanner = selectedPolicy && pathname.includes('dashboard') && !isAgent;

  return (
    <header tabIndex={-1} className={`header ${isAgent ? 'with-agent-banner' : ''}`}>
      <Container fluid={isTablet || isMobile}>
        {isAgent && <AgentBanner selectedPolicy={selectedPolicy} disableSearch={true} />}
        <Navbar />
        {showBanner && (
          <Banner
            title="HOMEPROTECT PRICE PROMISE"
            body="When we offer you a renewal price, it will always be the same as, or better than, the price offered to new customers"
          />
        )}
      </Container>
    </header>
  );
};
